'use client';
import { MuiOtpInput } from 'mui-one-time-password-input'; // Replace with the actual import
import styled from '@emotion/styled';

export const OtpTextfield = styled(
  ({ error, backgroundColor, borderColor, justifyContent, ...props }: OtpTextfieldProps) => (
    <div>
      <MuiOtpInput
        {...props}
        sx={{
          '& .MuiOutlinedInput-notchedOutline ': {
            borderColor: error ? 'error.main' : borderColor || 'grey.300',
            borderRadius: '10px',
          },
          '& .MuiInputBase-input.MuiOutlinedInput-input': {
            borderRadius: '10px',
            height: '56px',
            backgroundColor: backgroundColor || 'grey.300',
            fontSize: '20px',
            padding: '0px',
          },
          '& .MuiOutlinedInput-root.Mui-focused': {
            '& > fieldset': {
              borderColor: error ? 'error.main' : borderColor || 'grey.300',
            },
          },
          '& .MuiOutlinedInput-root:hover': {
            '& > fieldset': {
              borderColor: error ? 'error.main' : borderColor || 'grey.300',
            },
          },
          '& input[type=number]': {
            MozAppearance: 'textfield', // Firefox
          },

          '& input[type=number]::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
          '& input[type=number]::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
          },
        }}
      />
    </div>
  )
)`
  display: flex;
  gap: 9px;
  margin-inline: auto;
  ${({ justifyContent }) => (justifyContent ? { justifyContent } : {})}
`;

interface OtpTextfieldProps {
  error?: boolean;
  value?: string | undefined;
  onChange?: (newValue: string) => void;
  autoFocus?: boolean;
  length: number;
  TextFieldsProps: any;
  inputRef?: any;
  backgroundColor?: string;
  borderColor?: string;
  justifyContent?: string;
}
